import useGetAverageProductRating from './useGetAverageProductRating'

export default useGetAverageProductRating
